import React from 'react';
import { LoginForm } from "../components/LoginForm";

export default function LoginPage() {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="bg-black flex flex-col gap-4 p-6 md:p-10 min-h-screen">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs text-white bg-[#202020] p-5 rounded-[15px]">
            <LoginForm />
          </div>
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block">
        <img
          src="../camping.jpg"
          alt="Festival camping field with tents and blue sky"
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.5] dark:grayscale-[0.75]"
        />
      </div>
    </div>
  );
}

